<template>
  <a-form layout="vertical" :model="filters">
    <a-form-item label="ФИО">
      <a-input v-model:value="filters.name" placeholder="Фио"/>
    </a-form-item>

    <a-form-item label="Почта">
      <a-input v-model:value="filters.email" placeholder="Почта" />
    </a-form-item>

    <a-row justify="end" :gutter="8">
      <a-col>
        <a-button :class="'secondary-button'" @click="closeForm">Отменить</a-button>
      </a-col>
      <a-col>
        <a-button :class="'primary-button'" @click="updateFilters">Применить</a-button>
      </a-col>
    </a-row>
  </a-form>
</template>

<script>
import {onBeforeMount, reactive, ref, watch} from "@vue/runtime-core";
import {useStore} from "vuex";
import {computed} from "@vue/reactivity";

export default {
  props: {
    currentGroupId: [Number, String],
  },
  emits: ['close'],
  setup(props, context) {
    const currentFiltersLine = ref('');
    const store = useStore();
    const storedFilters = computed(() => store.state.users.filters);

    const filters = reactive({
      name: storedFilters.value.name ?? '',
      job_title: storedFilters.value.job_title ?? '',
      department: storedFilters.value.department ?? '',
      online_from: storedFilters.value.online_form ?? '',
      created_at: storedFilters.value.created_at ?? '',
      email: storedFilters.value.email ?? '',
      telephone: storedFilters.value.telephone ?? '',
      groups: storedFilters.value.groups ?? [],
      without_group_only: storedFilters.value.without_group_only ?? false,
    });

    const filterStringLabels = {
      name: 'ФИО',
      job_title: 'Должность',
      department: 'Подразделение',
      online_from: 'Дата входа',
      created_at: 'Дата создания',
      email: 'Почта',
      telephone: 'Телефон',
      groups: 'Группы',
      without_group_only: 'Без группы',
    }

    const buildInputLineString = () => {
      currentFiltersLine.value = '';
      Object.entries(filterStringLabels).map(
          ([key, value]) => {
            if (filters[key] && key !== 'groups') {
              let newString = `${value}: ${filters[key]}`;

              if (newString) {
                currentFiltersLine.value = (currentFiltersLine.value ? currentFiltersLine.value + ', ' : '') + `${newString}`
              }
            }
          }
      );
    }

    const updateFilters = () => {
      buildInputLineString();

      store.dispatch('users/setUserFilters', {
        filters: filters,
        filterString: currentFiltersLine,
      });

      closeForm();
    }

    const closeForm = () => {
      context.emit('close');
    }

    watch(storedFilters, () => {
      filters.name = storedFilters.value.name ?? '';
      filters.job_title = storedFilters.value.job_title ?? '';
      filters.department = storedFilters.value.department ?? '';
      filters.online_from = storedFilters.value.online_form ?? '';
      filters.created_at = storedFilters.value.created_at ?? '';
      filters.email = storedFilters.value.email ?? '';
      filters.telephone = storedFilters.value.telephone ?? '';
      filters.groups = storedFilters.value.groups ?? [];
      filters.current_group = storedFilters.value.current_group ?? null;
      filters.without_group_only = storedFilters.value.without_group_only ?? false;
    });

    return {
      filters,
      updateFilters,
      closeForm,
    }
  }
}
</script>

<style scoped lang="scss">
:deep(.ant-form-item-label) {
  padding-bottom: 4px !important;
}

:deep(.ant-form-item) {
  margin-bottom: 12px;
}
</style>